// extracted by mini-css-extract-plugin
export var deliveryRow = "_kz-a";
export var fixedHeight = "_kz-4";
export var freightLogo = "_kz-9";
export var fullWidth = "_kz-3";
export var priceColumn = "_kz-5";
export var radioSelected = "_kz-7";
export var radioUnselected = "_kz-6";
export var selectedOption = "_kz-2";
export var selectedOptionContainer = "_kz-1";
export var selection = "_kz-0";
export var tallSkeletonText = "_kz-8";